module.exports = __webpack_public_path__ + "img/waiting.b6d08edc.svg";